// src/hooks/useButtonSound.js
import { useEffect } from "react";
import btnClickSfx from "../music/tag/digitalb1.mp3";

export default function useButtonSound() {
  useEffect(() => {
    const handleClick = (e) => {
      if (e.target.closest("button")) {
        new Audio(btnClickSfx).play().catch((err) => console.warn(err));
      }
    };
    // third arg "true" = capture
    document.addEventListener("click", handleClick, true);
    return () => document.removeEventListener("click", handleClick, true);
  }, []);
}
